import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import StepList from "./StepList";
import  StepEdit  from "./StepEdit";

const StepPage = () => {
    let { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/edit/:stepId?`} component={StepEdit} />
            <Route default>
                <StepList />
            </Route>
        </Switch>
    );
};

export default StepPage;
